import React from 'react';
import * as Yup from 'yup';

import School from '../../../types/School';
import Teacher, { TeacherEditableFields } from '../../../types/Teacher';

import handleApiErrors from '../../../lib/apiClient/handleErrors';
import updateTeacher from '../../../lib/apiClient/teachers/update';
import deleteTeacher from '../../../lib/apiClient/teachers/delete';

import InputCell from '../../common/ui/Table/Cells/InputCell';
import SearchCell from '../../common/ui/Table/Cells/SearchCell';
import Row from '../../common/ui/Table/Row';

interface Props {
  teacher: Teacher;
  schools: Record<number, School>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;
}

const TeachersTableRow = ({
  teacher: { id, username, schoolId },
  schools,
  unauthorizedCallback,
  showError,
}: Props) => {
  const update = (teacher: TeacherEditableFields) =>
    handleApiErrors(
      updateTeacher(id, teacher),
      unauthorizedCallback,
      showError,
    );

  const destroy = () =>
    handleApiErrors(deleteTeacher(id), unauthorizedCallback, showError);

  const schoolsNames = Object.values(schools).map((school) => school.name);
  const schoolsSelectOptions = Object.values(schools).map((school) => ({
    id: school.id,
    label: school.name,
  }));

  const usernameValidationSchema = Yup.string()
    .required('Имя пользователя не может быть пустым')
    .min(4, 'Минимальная длина имени пользователя - 4 символа')
    .max(255, 'Максимальная длина имени пользователя - 255 символов');

  const schoolValidationSchema = Yup.string().oneOf(
    schoolsNames,
    'Указанной школы не существует',
  );

  return (
    <Row destroy={destroy}>
      <InputCell
        value={username}
        onConfirm={(value) => update({ username: value })}
        validationSchema={usernameValidationSchema}
        onValidationFailure={(error) => showError(error)}
      />

      <SearchCell
        value={schools[schoolId]?.name ?? ''}
        options={schoolsSelectOptions}
        onConfirm={(value) => update({ schoolId: value })}
        validationSchema={schoolValidationSchema}
        onValidationFailure={(error) => showError(error)}
      />
    </Row>
  );
};

export default TeachersTableRow;
